import { Button } from "../../shared/ui/button";

interface SetupPrimaryActionProps {
  hasActiveGame: boolean;
  liveEditable: boolean;
  battingCount: number;
  emptySlots: number;
  scheduleComplete: boolean;
  serverBusy: boolean;
  startPending?: boolean;
  startUnknown?: boolean;
  onShowGame: () => void;
  onStartGame: () => void;
}

export function SetupPrimaryAction({
  hasActiveGame,
  liveEditable,
  battingCount,
  emptySlots,
  scheduleComplete,
  serverBusy,
  startPending = serverBusy,
  startUnknown = false,
  onShowGame,
  onStartGame,
}: SetupPrimaryActionProps) {
  return (
    <div className="sticky bottom-20 z-[var(--z-sticky)] rounded-[var(--radius-lg)] border border-border bg-background/95 p-2 shadow-[var(--shadow-card)] backdrop-blur-md md:bottom-2">
      {hasActiveGame ? (
        <>
          <div className="mb-1.5 px-1 text-xs text-foreground-muted">
            {liveEditable
              ? "Live game changes save immediately"
              : "Completed game setup"}
          </div>
          <Button
            type="button"
            onClick={onShowGame}
            size="scoring"
            className="w-full"
          >
            RETURN TO GAME
          </Button>
        </>
      ) : (
        <>
          <div className="mb-1.5 flex items-center justify-between gap-2 px-1 text-xs text-foreground-muted">
            <span>
              {battingCount
                ? `${battingCount} batter${battingCount === 1 ? "" : "s"} ready`
                : "Add at least one batter"}
            </span>
            {emptySlots ? (
              <span className="text-warning">
                {emptySlots} empty slot{emptySlots === 1 ? "" : "s"}
              </span>
            ) : null}
          </div>
          <Button
            type="button"
            disabled={battingCount < 1 || !scheduleComplete}
            pending={startPending}
            pendingLabel={startUnknown ? "CHECKING…" : "STARTING GAME…"}
            onClick={onStartGame}
            size="scoring"
            className="w-full"
          >
            {`PLAY BALL — ${battingCount} BATTERS${
              emptySlots
                ? ` (${emptySlots} SLOT${emptySlots === 1 ? "" : "S"} EMPTY)`
                : ""
            }`}
          </Button>
        </>
      )}
    </div>
  );
}
